"use client";

import { SessionProvider } from "next-auth/react";
import { TooltipProvider } from "@/components/ui/tooltip";

type Props = {
  children: React.ReactNode;
};

export function AuthSessionProvider({ children }: Props) {
  return (
    <SessionProvider>
      <TooltipProvider delayDuration={300}>{children}</TooltipProvider>
    </SessionProvider>
  );
}

